import { classNamePrefixForWebComponentRendering, RenderMode } from './RenderContext';

const isEmpty = (value: string): boolean => value.trim().length === 0;
const isNotEmpty = (value: string): boolean => !isEmpty(value);

const updateClassNamesWithPrefix = (cssClassNames: string, mode: RenderMode): string => {
    if (mode !== RenderMode.WebComponent) return cssClassNames;
    if (isEmpty(cssClassNames)) return cssClassNames;

    const prefixWithHyphen = `${classNamePrefixForWebComponentRendering}-`;
    return cssClassNames
        .trim()
        .split(' ')
        .filter((name) => isNotEmpty(name))
        .map((name) => `${prefixWithHyphen}${name}`)
        .join(' ');
};

export { updateClassNamesWithPrefix };
